import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["scrollToTop", "scrollBehavior"],
  _excluded2 = ["scrollToTop", "scrollBehavior", "isRouterLink"];
import styled from 'foundations-theming/utils';
import TrellisRouterLink from 'ui-addon-react-router-dom/RouterLink';
import { Link as TrellisLink } from 'foundations-components/transitional/components/Link';

/**
 * A component that looks like a link but is in fact not
 * This should be used in the context of a containing component which
 * is actually a link. Do not use this component in place of a real link!
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const LikeLink = styled.span.withConfig({
  displayName: "AcademyLinks__LikeLink"
})(["color:", ";cursor:pointer;font-weight:500;transition:all 0.15s ease-out;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;&:hover{text-decoration:underline;color:", ";}"], ({
  theme,
  color
}) => color || theme.color['text-interactive-default'], ({
  theme,
  hoverColor
}) => hoverColor || theme.color['text-interactive-default-hover']);
export const RouterLink = _ref => {
  let {
      scrollToTop = false,
      scrollBehavior = 'auto'
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handleClick = event => {
    var _props$onClick;
    (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, event);
    if (scrollToTop) {
      window.scrollTo({
        top: 0,
        behavior: scrollBehavior
      });
    }
  };
  return /*#__PURE__*/_jsx(TrellisRouterLink, Object.assign({}, props, {
    onClick: handleClick,
    underline: false
  }));
};
export const MaybeRouterLink = _ref2 => {
  let {
      scrollToTop = false,
      scrollBehavior = 'auto',
      isRouterLink = false
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  if (isRouterLink) {
    return /*#__PURE__*/_jsx(RouterLink, Object.assign({}, props, {
      scrollBehavior: scrollBehavior,
      scrollToTop: scrollToTop,
      to: props.to
    }));
  }
  return /*#__PURE__*/_jsx(TrellisLink, Object.assign({}, props));
};
const StyledTrellisLink = styled.span.withConfig({
  displayName: "AcademyLinks__StyledTrellisLink"
})(["*{font-weight:500 !important;}"]);
export const Link = props => {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledTrellisLink, {
      children: /*#__PURE__*/_jsx(TrellisLink, Object.assign({}, props))
    })
  );
};